/**
 * Gathers the abtests stored on the window.
 * Must be called client-side only to prevent hydration mismatch.
 */
export default function loadExistingAbTests({ $abTests }) {
  const { existingAbTests } = window

  Object.assign($abTests, existingAbTests)
}
